import React from 'react';
import { getTvShows } from '../api/endpoints.js';
import { TvIcon } from '../components/icons.js';
import { CatalogListPage } from './CatalogListPage.js';

export function TvPage(): React.JSX.Element {
  return (
    <CatalogListPage
      title="Сериалы"
      icon={<TvIcon />}
      emptyDescription="Каталог сериалов сейчас пуст."
      fetchPage={getTvShows}
    />
  );
}
